import { render, staticRenderFns } from "./PolicyPrivate.vue?vue&type=template&id=122f23c3&lang=pug&"
import script from "./PolicyPrivate.vue?vue&type=script&lang=js&"
export * from "./PolicyPrivate.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPrivate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports